import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { FacilityOrderNewFlowHistoryListTemplate } from "themes/application/facility-order-new-flow/components";
import { FacilityOrderNewFlowHistoryListViewStore } from "application/facility-order-new-flow/stores";

@setCurrentView(rootStore => new FacilityOrderNewFlowHistoryListViewStore(rootStore), "facilityOrderNewFlowHistoryListViewStore")
@observer
class FacilityOrderNewFlowHistoryList extends React.Component {
    render() {
        return <FacilityOrderNewFlowHistoryListTemplate {...this.props} />;
    }
}

export default FacilityOrderNewFlowHistoryList;